module.exports = __webpack_public_path__ + "img/DaSo.212fc135.svg";